import React, { useCallback, useEffect } from "react";

import NewProfessionCategories from "../../components/Profession/NewProfessionCategories";
import NewProfessionCell from "../../components/Profession/ProfessionCell/NewProfessionCell";
import Props from "./props";
import SaveNewProfession from "../../components/Profession/SaveNewProfession";
import StyledTablePaper from "../../components/ui/TablePaper/styled";
import TablePaper from "../../components/ui/TablePaper";
import resetNewProfessionFieldsAction from "../../../state/actions/ProfessionActions/resetNewProfessionFieldsAction";
import sendNewProfessionAction from "../../../state/actions/ProfessionActions/sendNewProfessionAction";
import styled from "styled-components";
import { useAppTitle } from "../../../state/hooks/MainHooks/useAppTitle";
import { useDispatch } from "react-redux";
import useProfessionsAndCategories from "../../../state/hooks/ProfessionHooks/useProfessionsAndCategories";

interface Field {
    field: string;
    label: string;
}

const New: React.FC<Props> = (props) => {
    useProfessionsAndCategories();
    const dispatch = useDispatch();
    const resetNewProfessionFields = useCallback(() => dispatch(resetNewProfessionFieldsAction()), [dispatch]);
    const sendNewProfession = useCallback(() => dispatch(sendNewProfessionAction()), [dispatch]);
    const { setAppTitle } = useAppTitle();
    useEffect(() => {
        setAppTitle(props.title);
        return () => {
            setAppTitle("");
        };
    }, [setAppTitle, props.title]);
    useEffect(() => {
        return () => {
            resetNewProfessionFields();
        };
    }, [resetNewProfessionFields]);
    const fields: Field[] = [
        {
            field: "post_title",
            label: "Nome",
        },
        {
            field: "what_it_does",
            label: "Cosa fa",
        },
        {
            field: "who_is",
            label: "Chi è",
        },
        {
            field: "how_to_become",
            label: "Come diventare",
        },
        {
            field: "how_much_earns",
            label: "Quanto guadagna",
        },
        {
            field: "where_to_go",
            label: "A chi rivolgersi",
        },
    ];
    return (
        <Wrapper
            onSubmit={(e: React.FormEvent) => {
                e.preventDefault();
                sendNewProfession();
            }}
        >
            <SaveNewProfession />
            <TablePaper>
                {fields.map(({ field, label }) => (
                    <NewProfessionCell key={field} field={field} label={label} />
                ))}
                <NewProfessionCategories />
            </TablePaper>
        </Wrapper>
    );
};

export default New;

const Wrapper = styled.form`
    width: 60rem;
    margin: 0 auto;
    padding: 5rem 0;
    ${StyledTablePaper} {
        padding-top: 5rem;
    }
`;
